















import {formatString} from '@/shared/filters/utils-filter';
import {defineComponent} from "@vue/composition-api";
import {useGetters} from "vuex-composition-helpers";

export default defineComponent({
  name: 'PopupToggle',
  methods: {
    formatString
  },
  props: {
    numberOfActiveFilters: {type: Number}
  },
  setup: () => {
    const {labels} = useGetters(['labels'])

    return {
      labels
    }
  }
})
